import PrescriptionRenewalSurveyResults from './PrescriptionRenewalSurveyResults'
export default PrescriptionRenewalSurveyResults
